import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  cancelMakeRequest: ["make_id"],
  cancelMakeSuccess: ["makedata"],
  cancelMakeFailure: null,
});

export const CancelMakeTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  make_id: null,
  makedata: null,
});

export const CancelMakeSelectors = {
  getData: (state: any) => state.cancelMake.data,
  isFetching: (state: any) => state.cancelMake.fetching,
  isSuccess: (state: any) => state.cancelMake.success,
  hasError: (state: any) => state.cancelMake.error,
};

export const request = (state: any, action: any) => {
  const { make_id } = action;
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    make_id,
    makedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { makedata } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    makedata,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    makedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CANCEL_MAKE_REQUEST]: request,
  [Types.CANCEL_MAKE_SUCCESS]: success,
  [Types.CANCEL_MAKE_FAILURE]: failure,
});
